var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGooglePlay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 41,
    viewBox: "0 0 142 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M136.356 40.7482H5.24444C2.36131 40.7482 0 38.4548 0 35.6546V5.09349C0 2.29332 2.36131 -3.62396e-05 5.24444 -3.62396e-05H136.356C139.239 -3.62396e-05 141.6 2.29332 141.6 5.09349V35.6546C141.6 38.4548 139.239 40.7482 136.356 40.7482Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M136.356 0.816199C138.784 0.816199 140.76 2.73519 140.76 5.09349V35.6546C140.76 38.0129 138.784 39.9319 136.356 39.9319H5.24444C2.81627 39.9319 0.840422 38.0129 0.840422 35.6546V5.09349C0.840422 2.73519 2.81627 0.816199 5.24444 0.816199H136.356ZM136.356 -3.62396e-05H5.24444C2.36131 -3.62396e-05 0 2.29332 0 5.09349V35.6546C0 38.4548 2.36131 40.7482 5.24444 40.7482H136.356C139.239 40.7482 141.6 38.4548 141.6 35.6546V5.09349C141.6 2.29332 139.239 -3.62396e-05 136.356 -3.62396e-05Z",
    fill: "#A6A6A6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9449 7.6798C10.6368 7.99305 10.4585 8.48075 10.4585 9.11235V31.641C10.4585 32.2726 10.6368 32.7603 10.9449 33.0736L11.021 33.1423L24.0193 20.5231V20.2252L11.021 7.60594L10.9449 7.6798Z",
    fill: "url(#paint0_linear_4007_82799)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3473 24.7317L24.0193 20.5232V20.2252L28.3525 16.0167L28.4495 16.0714L33.5812 18.9072C35.0457 19.712 35.0457 21.0363 33.5812 21.8462L28.4495 24.6769L28.3473 24.7317Z",
    fill: "url(#paint1_linear_4007_82799)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4497 24.6769L24.0195 20.3741L10.9451 33.0736C11.4315 33.5702 12.2247 33.63 13.1268 33.1334L28.4497 24.6769Z",
    fill: "url(#paint2_linear_4007_82799)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4497 16.0714L13.1268 7.61487C12.2247 7.12334 11.4315 7.18319 10.9451 7.67981L24.0195 20.3741L28.4497 16.0714Z",
    fill: "url(#paint3_linear_4007_82799)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7358 10.4352C49.7358 11.2859 49.4736 11.9671 48.957 12.4752C48.363 13.0775 47.5895 13.3806 46.6416 13.3806C45.7356 13.3806 44.962 13.0724 44.3274 12.465C43.6916 11.8487 43.3743 11.0923 43.3743 10.1869C43.3743 9.28155 43.6916 8.52516 44.3274 7.91394C44.962 7.30145 45.7356 6.99329 46.6416 6.99329C47.0926 6.99329 47.5226 7.0837 47.933 7.25178C48.3421 7.42114 48.6751 7.65035 48.9163 7.93304L48.3683 8.47041C47.9474 7.9878 47.3745 7.74968 46.6416 7.74968C45.9808 7.74968 45.4078 7.97379 44.9214 8.42584C44.4402 8.87916 44.199 9.46619 44.199 10.1869C44.199 10.9077 44.4402 11.4998 44.9214 11.9531C45.4078 12.4001 45.9808 12.6293 46.6416 12.6293C47.343 12.6293 47.933 12.4001 48.3984 11.948C48.7052 11.6488 48.8796 11.2362 48.9255 10.709H46.6416V9.973H49.6886C49.7253 10.1322 49.7358 10.2863 49.7358 10.4352Z",
    fill: "#0F0F10",
    stroke: "#0F0F10",
    strokeWidth: 0.125867,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5699 7.88344H51.7077V9.81898H54.288V10.555H51.7077V12.4905H54.5699V13.2406H50.8975V7.13342H54.5699V7.88344Z",
    fill: "#0F0F10",
    stroke: "#0F0F10",
    strokeWidth: 0.125867,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9814 13.2406H57.1711V7.88344H55.4155V7.13342H59.7383V7.88344H57.9814V13.2406Z",
    fill: "#0F0F10",
    stroke: "#0F0F10",
    strokeWidth: 0.125867,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8665 13.2406V7.13342H63.6754V13.2406H62.8665Z",
    fill: "#0F0F10",
    stroke: "#0F0F10",
    strokeWidth: 0.125867,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2614 13.2406H66.4577V7.88344H64.6956V7.13342H69.0235V7.88344H67.2614V13.2406Z",
    fill: "#0F0F10",
    stroke: "#0F0F10",
    strokeWidth: 0.125867,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2076 12.4548C76.5874 13.0724 75.8191 13.3806 74.9027 13.3806C73.9809 13.3806 73.2126 13.0724 72.5925 12.4548C71.9736 11.8385 71.6655 11.0821 71.6655 10.1869C71.6655 9.29174 71.9736 8.53535 72.5925 7.91903C73.2126 7.30144 73.9809 6.99329 74.9027 6.99329C75.8139 6.99329 76.5822 7.30144 77.2024 7.92413C77.8264 8.54554 78.1346 9.29683 78.1346 10.1869C78.1346 11.0821 77.8264 11.8385 77.2076 12.4548ZM73.1917 11.9429C73.6584 12.4001 74.2261 12.6293 74.9027 12.6293C75.574 12.6293 76.1469 12.4001 76.6084 11.9429C77.0739 11.4858 77.3099 10.8987 77.3099 10.1869C77.3099 9.47511 77.0739 8.88808 76.6084 8.43093C76.1469 7.97379 75.574 7.74458 74.9027 7.74458C74.2261 7.74458 73.6584 7.97379 73.1917 8.43093C72.7262 8.88808 72.4902 9.47511 72.4902 10.1869C72.4902 10.8987 72.7262 11.4858 73.1917 11.9429Z",
    fill: "#0F0F10",
    stroke: "#0F0F10",
    strokeWidth: 0.125867,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M79.2712 13.2406V7.13342H80.2546L83.3121 11.8831H83.3475L83.3121 10.7091V7.13342H84.121V13.2406H83.2767L80.075 8.25655H80.0395L80.075 9.4357V13.2406H79.2712Z",
    fill: "#0F0F10",
    stroke: "#0F0F10",
    strokeWidth: 0.125867,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M71.466 22.1594C69.0024 22.1594 66.9899 23.9804 66.9899 26.4927C66.9899 28.9848 69.0024 30.8248 71.466 30.8248C73.9348 30.8248 75.9474 28.9848 75.9474 26.4927C75.9474 23.9804 73.9348 22.1594 71.466 22.1594ZM71.466 29.1185C70.1143 29.1185 68.9513 28.0348 68.9513 26.4927C68.9513 24.9303 70.1143 23.8658 71.466 23.8658C72.8178 23.8658 73.986 24.9303 73.986 26.4927C73.986 28.0348 72.8178 29.1185 71.466 29.1185ZM61.6996 22.1594C59.2307 22.1594 57.2234 23.9804 57.2234 26.4927C57.2234 28.9848 59.2307 30.8248 61.6996 30.8248C64.1671 30.8248 66.1757 28.9848 66.1757 26.4927C66.1757 23.9804 64.1671 22.1594 61.6996 22.1594ZM61.6996 29.1185C60.3465 29.1185 59.1796 28.0348 59.1796 26.4927C59.1796 24.9303 60.3465 23.8658 61.6996 23.8658C63.0513 23.8658 64.2143 24.9303 64.2143 26.4927C64.2143 28.0348 63.0513 29.1185 61.6996 29.1185ZM50.0779 23.4876V25.3289H54.6051C54.4727 26.3578 54.1187 27.1142 53.5759 27.6413C52.9151 28.278 51.8859 28.9847 50.0779 28.9847C47.2918 28.9847 45.1101 26.8009 45.1101 24.095C45.1101 21.389 47.2918 19.2052 50.0779 19.2052C51.5843 19.2052 52.6804 19.7769 53.4894 20.518L54.8254 19.2205C53.6939 18.1712 52.1888 17.3651 50.0779 17.3651C46.2573 17.3651 43.0464 20.3843 43.0464 24.095C43.0464 27.8056 46.2573 30.8248 50.0779 30.8248C52.1429 30.8248 53.6939 30.1677 54.9132 28.9351C56.1627 27.7216 56.5521 26.0152 56.5521 24.6374C56.5521 24.2096 56.5154 23.8161 56.4499 23.4876H50.0779ZM97.6004 24.915C97.232 23.946 96.0952 22.1594 93.7798 22.1594C91.4854 22.1594 89.5751 23.9154 89.5751 26.4927C89.5751 28.9198 91.4657 30.8248 94.0001 30.8248C96.0493 30.8248 97.232 29.6113 97.7184 28.9045L96.1975 27.9202C95.6901 28.6409 94.9991 29.1185 94.0001 29.1185C93.0076 29.1185 92.2956 28.6766 91.8394 27.8056L97.8062 25.4078L97.6004 24.915ZM91.5168 26.3578C91.4657 24.6871 92.8529 23.8314 93.8467 23.8314C94.6255 23.8314 95.2863 24.2096 95.5065 24.7508L91.5168 26.3578ZM86.667 30.5612H88.6285V17.8274H86.667V30.5612ZM83.4548 23.1247H83.3893C82.9487 22.6178 82.1083 22.1594 81.0437 22.1594C78.8096 22.1594 76.7668 24.0644 76.7668 26.5068C76.7668 28.9351 78.8096 30.8248 81.0437 30.8248C82.1083 30.8248 82.9487 30.3625 83.3893 29.8405H83.4548V30.4619C83.4548 32.1185 82.5436 33.0086 81.0738 33.0086C79.8755 33.0086 79.1321 32.1682 78.8253 31.4615L77.1195 32.1529C77.6112 33.3015 78.9131 34.715 81.0738 34.715C83.3735 34.715 85.314 33.4008 85.314 30.2034V22.423H83.4548V23.1247ZM81.2115 29.1185C79.8598 29.1185 78.7283 28.0195 78.7283 26.5068C78.7283 24.98 79.8598 23.8658 81.2115 23.8658C82.5436 23.8658 83.5938 24.98 83.5938 26.5068C83.5938 28.0195 82.5436 29.1185 81.2115 29.1185ZM106.783 17.8274H102.092V30.5612H104.048V25.7364H106.783C108.956 25.7364 111.086 24.2096 111.086 21.7812C111.086 19.3542 108.951 17.8274 106.783 17.8274ZM106.835 23.9651H104.048V19.5987H106.835C108.295 19.5987 109.129 20.7765 109.129 21.7812C109.129 22.7668 108.295 23.9651 106.835 23.9651ZM118.927 22.1352C117.514 22.1352 116.044 22.7414 115.439 24.0848L117.175 24.7915C117.549 24.0848 118.236 23.8556 118.962 23.8556C119.977 23.8556 121.006 24.4477 121.022 25.4931V25.6268C120.668 25.4282 119.91 25.134 118.978 25.134C117.108 25.134 115.203 26.1337 115.203 27.9992C115.203 29.7055 116.735 30.8044 118.456 30.8044C119.773 30.8044 120.499 30.2276 120.955 29.5565H121.022V30.5408H122.911V25.6561C122.911 23.3984 121.175 22.1352 118.927 22.1352ZM118.691 29.1134C118.051 29.1134 117.16 28.8052 117.16 28.0348C117.16 27.0492 118.271 26.671 119.234 26.671C120.095 26.671 120.499 26.8557 121.022 27.0989C120.869 28.278 119.824 29.1134 118.691 29.1134ZM129.795 22.4141L127.546 27.9342H127.479L125.155 22.4141H123.045L126.538 30.1282L124.545 34.4208H126.589L131.971 22.4141H129.795ZM112.162 30.5612H114.123V17.8274H112.162V30.5612Z",
    fill: "#0F0F10"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4007_82799",
    x1: 22.8652,
    y1: 31.8756,
    x2: 5.77619,
    y2: 14.2803,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4007_82799",
    x1: 35.4883,
    y1: 20.3728,
    x2: 10.1084,
    y2: 20.3728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4007_82799",
    x1: 26.0407,
    y1: 18.0351,
    x2: 2.86656,
    y2: -5.82567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4007_82799",
    x1: 7.65397,
    y1: 40.5688,
    x2: 18.0023,
    y2: 29.914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlay);
export default __webpack_public_path__ + "static/media/Google-Play.6aef26d19c8e6dbdded13d06ac918539.svg";
export { ForwardRef as ReactComponent };